import { render } from "./EditorModal.vue?vue&type=template&id=58c4e3ca"
import script from "./EditorModal.vue?vue&type=script&lang=js"
export * from "./EditorModal.vue?vue&type=script&lang=js"

import "./EditorModal.vue?vue&type=style&index=0&id=58c4e3ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__